<form [formGroup]="finalizarForm">
    <h2 style="width: 375px;" mat-dialog-title>Finalizar tarea</h2>
    <mat-dialog-content>
        <mat-form-field class="full-width">
            <mat-label>Comentario</mat-label>
            <textarea matInput formControlName="comentario"></textarea>
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button type="button" mat-button mat-dialog-close cdkFocusInitial>Cancelar</button>
        <button type="submit" mat-flat-button (click)="onSubmitForm()"
            [disabled]="!finalizarForm.valid || fetchingFinalizarTarea">
            <div class="btn-login-content">
                @if (fetchingFinalizarTarea) {
                <mat-spinner diameter="20" color="warn"></mat-spinner>
                }@else{
                <p>Aceptar</p>
                }
            </div>
        </button>
    </mat-dialog-actions>
</form>